export default "__VITE_ASSET__C6a9LVRW__"